import { getKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { toRem } from '@nxtpeople/nxt-vue-library';
import 'bootstrap/dist/css/bootstrap.css';
import mitt from 'mitt';
import { createApp } from 'vue';
import App from './App.vue';
import { checkAccess } from './core/helpers/auth.helper';
import { setupDirectives } from './core/helpers/directives.helper';
import keycloak from './core/helpers/keycloak.helper';
import { initSentry } from './core/helpers/sentry.helper';
import router from './core/router';
import store from './core/store';
import i18n from './i18n';

const emitter = mitt();

const app = createApp(App);

initSentry(app, router);

app.use(keycloak);
app.use(i18n);
app.use(router);
app.use(store);

setupDirectives(app);

app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$keycloak = getKeycloak();
app.config.globalProperties.$toRem = (px: number) => toRem(px, 13);
app.config.globalProperties.$auth = checkAccess;

app.mount('#app');
